import {
  CART_ID_PARAM_ID,
  GRP_PARAM_ID,
  PRODUCT_ID_PARAM_ID,
} from "Constants/queryParams";
import { ToggleData, UrlData } from "./testUtils";

import { MainPath } from "Constants/constants";
import { isDefined } from "Utils/functions";
import { getQueryString } from "Utils/navigation/queryParameterUtils";

export const getEditUrl = (
  toggleData: ToggleData,
  urlData: UrlData,
): string => {
  const { productURL, cartId, productId } = urlData;
  const editUrl = `/${MainPath.CHECK_PRICE}/${productURL.newUrl}`;

  /* Set up partner parameter */
  const queryParams = new URLSearchParams(window.location.search);
  if (isDefined(toggleData.cartPartner)) {
    queryParams.set(GRP_PARAM_ID, toggleData.cartPartner);
  }

  queryParams.set(CART_ID_PARAM_ID, cartId);
  queryParams.set(PRODUCT_ID_PARAM_ID, productId);
  return `${editUrl}${getQueryString(queryParams)}`;
};
